import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {calendarDate} from 'shared/tools';
import SurveyQuestion from './SurveyQuestion';
import SurveyResponse from './SurveyResponse';
import SurveyEmployeeStatus from './SurveyEmployeeStatus';
import _ from 'lodash';

class Survey extends DomainObject {
  name;
  launchedAt;
  dueDate;
  questions;
  responses;
  closedAt;
  anonymous;
  currentPeriodDate;
  employeeStatuses;

  completeStatusCount;
  incompleteStatusCount;
  totalStatusCount;

  _relations = {
    questions: [SurveyQuestion],
    responses: [SurveyResponse],
    employeeStatuses: [SurveyEmployeeStatus],
    _dates: ['launchedAt', 'closedAt', 'dueDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      launchedAt: observable,
      dueDate: observable,
      questions: observable,
      responses: observable,
      closedAt: observable,
      anonymous: observable,
      currentPeriodDate: observable,
      employeeStatuses: observable,
      completeStatusCount: observable,
      incompleteStatusCount: observable,
      totalStatusCount: observable,
      sortedQuestions: computed,
      completedPercentage: computed,
      launchedAtView: computed,
      isLaunched: computed,
      isClosed: computed,
      isRecurring: computed
    });

    this.merge(other);
  }

  get sortedQuestions() {
    return _.sortBy(this.questions, 'order');
  }

  get completedPercentage() {
    return _.ceil((this.completeStatusCount / this.totalStatusCount) * 100);
  }

  get launchedAtView() {
    if (this.currentPeriodDate) {
      return calendarDate(this.currentPeriodDate);
    } else {
      return calendarDate(this.launchedAt);
    }
  }

  get isLaunched() {
    return !!this.launchedAt;
  }

  get isClosed() {
    return !!this.closedAt;
  }

  get isRecurring() {
    return !(this.currentPeriodDate == null);
  }
}

export default Survey;
